import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-542a72a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "worp_content" }
const _hoisted_3 = { class: "cou_list" }

import { Tabs } from 'ant-design-vue';
import { computed, defineAsyncComponent, ref } from 'vue';
import { emptyDataSec } from '@/assets';
import { IList } from './type';
import axios from '@/api/account';

export default /*#__PURE__*/_defineComponent({
  __name: 'CardBag',
  setup(__props) {

const CardSquare = defineAsyncComponent(() => import('./CardSquare.vue'));

const aTabs = Tabs;
const aTabPane = Tabs.TabPane;

const tabs = [
  {
    key: 1,
    title: '全部',
  },
];
const activeKey = ref(1);

const background = [
  require('@/assets/resource/bag_invalid.png'), //失效
  require('@/assets/resource/bag_replace.png'), //代金券
  require('@/assets/resource/bag_increase.png'), // 增值
  require('@/assets/resource/bag_experience.png'), // 体验
];
const list = ref<IList[]>([]);

const getListData = () => {
  const data = { type: -1, hidden_expire: 0 };
  axios.getCardCouponList({ params: data }).then((res) => {
    list.value = res.data.data.data.map((e: any) => new IList(e));
  });
};
getListData();
const dataList = computed(() => {
  list.value.map((e) => {
    switch (e.type) {
      case 1:
        e.background = '代金券';
        e.status ? (e.background = background[1]) : (e.background = background[0]);
        break;
      case 4:
        e.background = '增值券';
        e.status ? (e.background = background[2]) : (e.background = background[0]);
        break;
      case 5:
        e.background = '体验券';
        e.status ? (e.background = background[3]) : (e.background = background[0]);
        break;
    }
  });
  return list.value;
});

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(dataList).length === 0)
        ? (_openBlock(), _createBlock(_component_a_empty, {
            key: 0,
            class: "null_img",
            image: _unref(emptyDataSec),
            description: "暂无卡券~"
          }, null, 8, ["image"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item_box",
            key: item.id
          }, [
            _createVNode(_unref(CardSquare), { "data-source": item }, null, 8, ["data-source"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})